module.exports = __webpack_public_path__ + "img/email_grey_border.306b246c.svg";